module.exports = __webpack_public_path__ + "img/Proliferation-GBM_10X_WTA.8d1767fe.png";